/*  UI  */
import { Box, Flyout, Form } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { Z_INDEX } from 'application/Shared/Constants';

/*  Packages  */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FieldSchemaJson } from '../Form/Field.type';
import { FieldFactory } from '../Form/FieldFactory';
import { useDashboardContext } from './DashboardContext';

export const About = () => {
    const {
        dashboardState: {
            refreshDashboard,
            dataUpdatedAt,
            autoAdjust,
            showAbout,
            isFiltrable,
            isSearchable
        },
        schema: dashboard,
        context: dashboardContext,
        setShowAbout
    } = useDashboardContext();

    const { t } = useTranslation();

    const fields: FieldSchemaJson[] = [
        {
            control: { readOnly: true, type: 'text' },
            label: t('Dashboard.About.dashboardId'),
            name: 'dashboardId',
            type: 'string'
        },
        {
            control: { readOnly: true, type: 'text' },
            label: t('Dashboard.About.dashboardVersion'),
            name: 'dashboardVersion',
            type: 'string'
        },
        {
            control: { readOnly: true, type: 'text' },
            label: t('Dashboard.About.dataUpdatedAt'),
            name: 'dataUpdatedAt',
            type: 'string'
        },
        {
            control: { readOnly: true, type: 'text' },
            label: t('Dashboard.About.refreshDashboard'),
            name: 'refreshDashboard',
            type: 'number'
        },
        {
            control: { readOnly: true, type: 'checkbox' },
            label: t('Dashboard.About.autoAdjust'),
            name: 'autoAdjust',
            type: 'boolean'
        },
        {
            control: { readOnly: true, type: 'checkbox' },
            label: t('Dashboard.About.isFiltrable'),
            name: 'isFiltrable',
            type: 'boolean'
        },
        {
            control: { readOnly: true, type: 'checkbox' },
            label: t('Dashboard.About.isSearchable'),
            name: 'isSearchable',
            type: 'boolean'
        },
        {
            control: { readOnly: true, type: 'text-area' },
            label: t('Dashboard.About.context'),
            name: 'context',
            type: 'string'
        }
    ];

    const formDefaultValues = {
        autoAdjust,
        context: JSON.stringify(dashboardContext, null, 2),
        dashboardId: dashboard.id,
        dashboardVersion: dashboard.schemaVersion,
        dataUpdatedAt: dataUpdatedAt
            ? new Date(dataUpdatedAt).toLocaleString()
            : t('Common.never'),
        isFiltrable,
        isSearchable,
        refreshDashboard,
        showAbout
    };

    return showAbout ? (
        <Flyout
            onClose={() => setShowAbout(false)}
            title={t('Dashboard.About')}
            zIndex={Z_INDEX.FLYOUT_MEDIUM}
        >
            <Box padding="24px" width="640px" height="calc(100vh - 82px)">
                <Form onSubmit={() => {}} defaultValues={formDefaultValues}>
                    {fields.map((field) => (
                        <FieldFactory key={field.name} schema={field} />
                    ))}
                </Form>
            </Box>
        </Flyout>
    ) : null;
};
